import { trans } from '@pepita-i18n/babelfish';
import * as Yup from 'yup';
import { RegisterFormValues } from '../types';
import { requiredEmail, requiredPhoneWithoutPrefix } from 'constants/yupValidations';
import gtxConstants from '@getrix/common/js/gtx-constants';

export const authFormValidSchema = Yup.object().shape({
    nome: Yup.string().required(trans('register.form.error.name')),
    cognome: Yup.string().required(trans('register.form.error.surname')),
    email: requiredEmail(),
    idComune: Yup.number().required(trans('register.form.error.municipality')),
    nomesocieta: Yup.string().required(trans('register.form.error.company_name')),
    telefono: requiredPhoneWithoutPrefix(),
    privacy: Yup.bool().isTrue(trans('register.form.error.privacy')),
    piva: gtxConstants('AGENCY_REGISTRATION_VAT_FIELD')
        ? Yup.string().required(trans('label.insert_vat_number'))
        : Yup.string().nullable().notRequired(),
} as {
    //typing here to keep track of field name changes
    [K in keyof RegisterFormValues]: any; // eslint-disable-line
});
